import { apiRequest } from "./apiService";

/**
 * GET /trending?userId=...
 */
export const fetchTrendingTopics = (userId) => {
  const query = userId ? `?userId=${encodeURIComponent(userId)}` : "";
  return apiRequest(`/trending${query}`, "GET");
};
